import { Component, OnInit } from '@angular/core';
import { Form, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentosService } from 'src/app/services/documentos.service';
import { UserService } from 'src/app/services/user.service';
import * as FormActions from '../../reducers/actions/forms.actions';
import { PerfilComponent } from '../perfil/perfil.component';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';

interface AppState {
  form: Form;
}
declare const swal: any;

@Component({
  selector: 'app-validar-documentos',
  templateUrl: './validar-documentos.component.html',
  styleUrls: ['./validar-documentos.component.css'],
  providers: [DocumentosService, ClaveUnicaService]
})
export class ValidarDocumentosComponent implements OnInit {

  public cod = new FormControl('', [Validators.required]);
  public codParametro
  public identity

  constructor(
    private _cert: DocumentosService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private _router: Router,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _userService: UserService,
    private claveUnicaService: ClaveUnicaService
  ) {
    this.identity = this._userService.getIdentity();

    this.activatedRoute.params.subscribe(async (params) => {
      console.log("parametros ruta", params);

      this.codParametro = await params['cod'];

      if (this.codParametro) {
        this.getLink(this.codParametro, 'parametro');
      }
    });

    /*  if (sessionStorage.getItem('identity-domCloud')) {
       this.searchUser()
     } else {
       this._router.navigate(['/inicio'])
       swal({
         type: 'warning',
         text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
         showConfirmButton: true,
         confirmButtonText: 'Aceptar',
         allowOutsideClick: false
       })
     } */
  }

  ngOnInit() {

  }

  buscar() {
    this.getLink(this.cod.value, 'dom');
  }


  getLink(cod, vista) {
    this.spinner.show()

    console.log("Vista", vista);
    console.log("Codigo que se buscara", cod);

    this._cert.getLinkByCod(cod).subscribe(response => {

      console.log(response);
      if (response.data) {
        if (vista == 'dom') {
          window.open(response.data, '_blank');
        }
        if (vista == 'parametro') {
          window.open(response.data, "_self");
        }
      } else {
        console.log("no llego la info");

      }

      this.spinner.hide()
    }, error => {
      console.log(error)
      this.spinner.hide()

    })
  }


  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");

    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
    this.back()
  }

  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  back() {
    this._router.navigate(['/inicio'])
  }


  searchUser() {
    /* Buscar si existe en fm */
    let identityData = this._userService.getIdentity();
    let rut = identityData.rut + identityData.dv
    this._userService.buscarUsuario(rutClean(rut)).subscribe(
      response => {
        if (response.message) {
          this.spinner.hide();
          console.log(response);

        }
        if (response.register) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });
        }

        if (response.update) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });
        }

      },
      error => {
        let e = JSON.parse(error._body);
        this.spinner.hide();
      }
    )
  }
}
